import React, {useState} from 'react';
import { Link } from 'react-router-dom';
import {FaBuilding, FaKey, FaUserPlus} from 'react-icons/fa';
import './InstituteDashboard.css';
import ResetPasswordForm from "../component/ResetPasswordForm";
import {useSelector} from "react-redux";

function InstituteDashboard() {
    const email = useSelector(state => state.authentication.email);
    const [showResetForm, setShowResetForm] = useState(false);
    const resetPasswordForm = () => {
        setShowResetForm(false);
    }

    return (
        <>
            {!showResetForm && (
                <div className="dashboard-container">
                    <h2 className="dashboard-title">Institut-Dashboard</h2>
                    <div className="dashboard-links">
                        <Link to="/mdb/institute/overview" className="dashboard-link">
                            <FaBuilding className="icon"/>
                            Übersicht der Mitverwendungen
                        </Link>
                        <Link to="/mdb/institute/employment/new" className="dashboard-link">
                            <FaUserPlus className="icon"/>
                            Mitverwendung anlegen
                        </Link>
                        <a onClick={() => setShowResetForm(1)} className="dashboard-link">
                            <FaKey className="icon"/>
                            <span>Passwort zurücksetzen</span>
                        </a>
                    </div>
                </div>
            )}
            {showResetForm && (
                <div className="dashboard-container">
                    <h2 className="dashboard-title">Passwort resetten</h2>
                    <div className="row header-row d-none d-md-flex">
                        <div className="col">
                            <ResetPasswordForm previousStep={resetPasswordForm} showPassword="1" emailAddress={email}/>
                        </div>
                    </div>
                </div>
            )}
        </>
    );
}

export default InstituteDashboard;

